export default class NotImplemented extends Error {
  constructor(message?: string) {
    super(message);  // Pass message to the base Error class
    this.name = 'NotImplemented'  // Assign a custom error name
  }
}
